// extracted by mini-css-extract-plugin
export default {"overlay":"ImagePriview_overlay__eXRLh","modal":"ImagePriview_modal__higoo","previewImage":"ImagePriview_previewImage__TZFeg","closeButton":"ImagePriview_closeButton__jlzHf"};